<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconEdit_16"
    viewBox="0 0 16 16"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        fill-rule="evenodd"
        d="M12.041 2c-.52 0-1.018.206-1.385.574l-7.845 7.844a.63.63 0 0 0-.165.292l-.627 2.51a.628.628 0 0 0 .76.761l2.511-.627a.63.63 0 0 0 .292-.165l7.844-7.845A1.96 1.96 0 0 0 12.041 2"
        clip-rule="evenodd"
    />
</svg>
